/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const LockOneIcon = /*#__PURE__*/ createSvgIcon(
  'LockOneIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.529 6a.5.5 0 01.5-.5h9.994a.5.5 0 01.5.5v9a.5.5 0 01-.5.5H3.03a.5.5 0 01-.5-.5V6zm1 .5v8h8.994v-8H3.53z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.983 1.054C6.496.71 7.157.5 7.995.5c.838 0 1.5.211 2.012.554.51.34.843.79 1.06 1.226a4.198 4.198 0 01.427 1.676l.001.033v.016l-.5.001h.5V6a.5.5 0 11-1 0V4.006v.001V3.99a3.2 3.2 0 00-.04-.37 3.2 3.2 0 00-.282-.893 2.137 2.137 0 00-.721-.84C9.12 1.663 8.657 1.5 7.995 1.5s-1.126.164-1.457.385a2.137 2.137 0 00-.72.841 3.2 3.2 0 00-.322 1.263v.017h-.5.5V6a.5.5 0 01-1 0V4.006h.5-.5V3.99a1.971 1.971 0 01.006-.149 4.199 4.199 0 01.42-1.562c.218-.434.551-.885 1.061-1.225zM9.53 9.936a1.504 1.504 0 00-3.008 0 1.5 1.5 0 00.752 1.296v1.337h1.504V11.23c.448-.26.752-.74.752-1.295z"
            fill="currentColor"
          />
        </>
      ),
      medium: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.5 7a.5.5 0 01.5-.5h14a.5.5 0 01.5.5v12a.5.5 0 01-.5.5H3a.5.5 0 01-.5-.5V7zm1 .5v11h13v-11h-13z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.298 1.226C7.98.78 8.865.5 10 .5c1.136 0 2.02.28 2.702.726a4.137 4.137 0 011.419 1.608c.292.573.435 1.14.506 1.56a5.45 5.45 0 01.073.708V5.121l-.5.001h.5V7a.5.5 0 01-1 0V5.093l-.007-.112a4.457 4.457 0 00-.051-.42 4.497 4.497 0 00-.412-1.273 3.139 3.139 0 00-1.075-1.226c-.5-.327-1.19-.562-2.155-.562-.964 0-1.654.235-2.154.562-.503.33-.843.77-1.075 1.226-.233.457-.352.92-.412 1.274a4.47 4.47 0 00-.058.53v.03h-.5.5V7a.5.5 0 01-1 0V5.122h.5-.5v-.02a2.472 2.472 0 01.009-.193 5.47 5.47 0 01.063-.515c.071-.42.215-.987.507-1.56a4.137 4.137 0 011.418-1.608zM12.083 12.219a2.083 2.083 0 00-4.166 0c0 .77.422 1.434 1.042 1.794v1.85h2.082v-1.85a2.072 2.072 0 001.042-1.794z"
            fill="currentColor"
          />
        </>
      ),
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.105 1.288C9.833.805 10.78.5 12 .5s2.168.305 2.895.788a4.463 4.463 0 011.516 1.743c.312.62.465 1.236.541 1.692a6.022 6.022 0 01.078.766V5.509l-.5.001h.5v2.17a.5.5 0 11-1 0V5.505a2.412 2.412 0 00-.008-.153 4.99 4.99 0 00-.056-.464 5.025 5.025 0 00-.45-1.409 3.463 3.463 0 00-1.174-1.358C13.796 1.76 13.046 1.5 12 1.5s-1.796.259-2.342.621c-.55.365-.922.854-1.175 1.358a5.025 5.025 0 00-.45 1.409 5.01 5.01 0 00-.063.617v.006l-.5-.001h.5V8a.5.5 0 01-1 0V5.51h.5-.5v-.021a2.706 2.706 0 01.01-.209c.01-.136.03-.328.068-.557.076-.456.23-1.071.541-1.692a4.462 4.462 0 011.516-1.743z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.51 8.33a.5.5 0 01.5-.5H19.9a.5.5 0 01.5.5V23a.5.5 0 01-.5.5H4.01a.5.5 0 01-.5-.5V8.33zm1 .5V22.5H19.4V8.83H4.51z"
            fill="currentColor"
          />
          <path
            d="M14.3 14.79a2.35 2.35 0 10-3.52 2v2.08h2.34v-2.06a2.35 2.35 0 001.18-2.02z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default LockOneIcon;
